import { UUID } from '@/plugins/common'
import Process from './process'
import _ from 'lodash'
import img from './assets/icon.png'

export default class Definition {
  id = ''
  // 流程名字
  name = ''
  // 流程分组
  category = ''
  // 流程版本信息
  process = {}

  // 流程当前版本
  currentProcessId = ''
  state = true

  appSwitch = false
  // 图标
  appIcon = img
  //  转交
  turnOnReassign = false
  // 备注
  comment = ''
  // 分组导航
  groupNav = false

  constructor (args = {}) {
    _.merge(this, args)
    // this.process = new Process(args.process)
    // this.currentProcessId = this.process.id
  }

  static create (args) {
    let definition = new Definition({'id': '_' + UUID.create()})
    definition.process = Process.create({'definitionId': definition.id})
    definition.currentProcessId = definition.process.id
    return definition
  }

  static load (args) {
    let definition = new Definition(args)
    definition.appIcon = args.appIcon || img
    definition.process = Process.load(args.process)
    // 有点奇怪
    definition.currentProcessId = definition.process.id
    return definition
  }

  resetProcess () {
    this.name = ''
    let definition = new Definition({'id': '_' + UUID.create()})
    return definition
  }
}



// WEBPACK FOOTER //
// ./src/store/process/definition.js